export default "__VITE_ASSET__DOZpLWkG__"